<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h4 qid="v-view-page-title" class="mb-3">
              {{ retentionRule.name }}
            </h4>
            <div class="mb-2">
              <span v-if="getGuide('vulnerability')">
                <GuideButton :guide="getGuide('vulnerability')"></GuideButton>
              </span>
            </div>
          </div>

          <div class="col-md-6 text-right" qid="view-v-modified">
            <div class="mb-4">
                <span class="h6 ml-3">
                <span v-if="isGranted([permissions.RETENTION_RULE_EDIT, permissions.RETENTION_RULE_EDIT_OWN], retentionRule.created_by) && (!getClient.parent || (getClient.parent && retentionRule.partition))"
                      class="btn btn-edit"
                      qid="edit-v-button"
                      @click="showEditRRModal(retentionRule)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span v-if="isGranted([permissions.RETENTION_RULE_DELETE, permissions.RETENTION_RULE_DELETE_OWN], retentionRule.created_by) && (!getClient.parent || (getClient.parent && retentionRule.partition))"
                      class="btn btn-delete"
                      qid="delete-v-button"
                      @click="showConfirmDeleteModal(retentionRule)"
                >
                  <font-awesome-icon icon="trash-alt"/>
                </span>
              </span>
            </div>
            <div>
              <span>{{ $t('table.last_updated') }}</span>
              <span class="ml-2 text-muted small" qid="view-v-modified-date">
              {{ retentionRule.updated_at | formatDate }}
            </span>
              <Avatar v-if="retentionRule.updated_by" :object="retentionRule.updated_by" size="xs" class="ml-3 mr-2"></Avatar>
              <span v-if="retentionRule.updated_by" qid="view-v-modified-by">
              {{ retentionRule.updated_by.name }}
            </span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="content-view-body">
          <br>
          <div class="mt-3">
            <p class="text-dark">
              {{ $t('maintenance.vulnerabilities.create.description_label') }}
            </p>
            <hr>
            <p qid="v-description" class="text-formatted">
              {{ retentionRule.description }}
            </p>
            <br>
          </div>
        </div>
      </div>
    </div>


    <!-- Edit retention rule modal template -->
    <b-modal ref="edit-retention-rule" hide-footer>
      <div class="d-block text-center">
        <h4 qid="update-v-title">
          {{ $t('maintenance.vulnerabilities.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-v-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editRRFormSubmit" qid="edit-v-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-v-name-label">
              {{ $t('maintenance.vulnerabilities.create.name_label') }}
            </label>
            <b-form-input
              qid="edit-v-form-name"
              type="text"
              v-model="vForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.vulnerabilities.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-v-description-label">
              {{ $t('maintenance.vulnerabilities.create.description_label') }}
            </label>
            <b-form-textarea
              qid="edit-v-form-description"
              v-model="vForm.description"
              rows="6"
              max-rows="6"
              required
              :placeholder="$t('maintenance.vulnerabilities.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditRRModal"
                    qid="edit-v-cancel-button"
          >
            {{ $t('maintenance.vulnerabilities.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-v-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.vulnerabilities.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Delete retention rule confirm modal template -->
    <b-modal ref="delete-retention-rule" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-v-title">
          {{ $t('maintenance.vulnerabilities.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.vulnerabilities.delete.description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.vulnerabilities.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="delete-v-cancel-button"
        >
          {{ $t('maintenance.vulnerabilities.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteRR(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-v-submit-button"
                  v-if="isGranted([permissions.RETENTION_RULE_DELETE, permissions.RETENTION_RULE_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
        >
          {{ $t('maintenance.vulnerabilities.delete.submit') }}
        </b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import {initialsAvatarUrl} from '@/util/userAvatar.js';
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js'
import Avatar from '@/components/Avatar.vue';
import GuideButton from '@/components/guide/GuideButton.vue';


export default {
  name: 'RetentionRuleView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('maintenance.title'),
          to: '/maintenance'
        },
        {
          text: this.$t('maintenance.vulnerabilities.title'),
          to: '/maintenance/vulnerabilities'
        }
      ],
      retentionRule: {},
      showInput: false,
      showSingleLinkLabel: true,
      inputLink: '',
      itemToDelete: {},
      vForm: {
        name: '',
        description: '',
        client:'',
      },
      error: '',
      timeLimitItems: [],
      timeLimitInput: '',
      buttonDisabled: false,
      selectedFile: {},
      selectedLink: {},
      showDeleteAttachmentModal: false,
      showDeleteLinkModal: false,
      myGuides: [],
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug !== oldValue.slug) {
        this.goToList()
      } else {
        this.loadContent();
      }
    }
  },
  components: {
    Avatar,
    GuideButton
  },
  methods: {
    goToList() {
      this.$router.push('/maintenance/vulnerabilities')
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Maintenance' && object.enabled
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Maintenance',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    openHelpCenter(object) {
      let topElement = document.getElementById("app");
      if (topElement.classList.contains("guide-collapsed")) {
        topElement.classList.toggle("guide-collapsed");
      }
      if (!topElement.classList.contains("activity-collapsed")) {
        topElement.classList.toggle("activity-collapsed");
      }

      this.$store.commit('storeHelpCenterState', true);
      this.$store.commit('storeActiveGuideScope', object);
    },
    loadContent() {
      let self = this;
      piincHttp.get('vulnerabilities/' + this.$route.params.slug, { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.retentionRule = response.data;
        // Push content name in breadcrumb array
        self.breadcrumbItems.push({text: self.retentionRule.name, active: true});
      }, function() {});
    },
    getUserAvatar(user){
      if (user && user.avatar) {
        return user.avatar;
      } else {
        return initialsAvatarUrl(user);
      }
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-retention-rule'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-retention-rule'].hide()
    },
    confirmDeleteRR(object) {
      let self = this;
      piincHttp.delete('vulnerabilities/' + object.slug).then(function() {
        self.hideConfirmDeleteModal();
        self.goToList();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('maintenance.vulnerabilities.delete.success'))
      }, function() {});
    },
    showEditRRModal(object) {
      let self = this;

      this.vForm.slug = object.slug;
      this.vForm.name = object.name;
      this.vForm.description = object.description;

      this.$refs['edit-retention-rule'].show()
    },
    hideEditRRModal() {
      this.timeLimitInput = ''
      this.$refs['edit-retention-rule'].hide()
    },
    editRRFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();
      this.vForm.client = this.getClient.slug;

      piincHttp.put('vulnerabilities/' + this.vForm.slug, this.vForm).then(function(response) {
        self.hideEditRRModal();
        self.buttonDisabled = false;
        // If slug is not changed, just reload content
        if (response.data.slug === self.retentionRule.slug) {
          // Remove last item in breadcrumbs, because it will be added again on load content
          self.breadcrumbItems.pop();
          self.loadContent();
        } else {
          // If slug changed, reload state with new param
          self.$router.push({ name: 'maintenance.vulnerabilities.view', params: { slug: response.data.slug }})
        }
        self.$toastr('success', self.$t('maintenance.vulnerabilities.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    }
  },
  created () {
    if (this.getClient && this.getClient.slug) {
      this.loadContent();
    }
    this.loadGuides('vulnerability');
  }
}
</script>
